// src/components/minigames/StudentGame.jsx
import React, { useState } from 'react';
import LibraryScreen from './LibraryScreen';
import MusicPlayerV2 from "./MusicPlayerV2"; // ✅ ruta actualizada
import DocPlayer from './DocPlayer';
import './StudentGame.css';

// screen: 'library' | 'music' | 'doc' | 'results'
// selectedContent: { ...songOrVideoDetail }
// results: { score, correct, total, title, mode }

export default function StudentGame({ token }) {
    const [screen, setScreen] = useState('library');
    const [content, setContent] = useState(null);
    const [results, setResults] = useState(null);

    const goLibrary = () => { setScreen('library'); setContent(null); setResults(null); };

    const startGame = (item) => {
        setContent(item);
        setScreen(item.mode); // 'music' | 'doc'
    };

    const finishGame = (res) => {
        setResults(res);
        setScreen('results');
    };

    const renderScreen = () => {
        if (screen === 'library') {
            return <LibraryScreen token={token} onStart={startGame} />;
        }
        if (screen === 'music' && content) {
            return <MusicPlayerV2 token={token} song={content} onFinish={finishGame} onBack={goLibrary} />;
        }
        if (screen === 'doc' && content) {
            return <DocPlayer token={token} video={content} onFinish={finishGame} onBack={goLibrary} />;
        }
        if (screen === 'results' && results) {
            return <ResultsScreen results={results} onHome={goLibrary} />;
        }
        return null;
    };

    return (
        <div id="nc-fullscreen-wrap" className="nc-fullscreen-wrap">
            {renderScreen()}
        </div>
    );
}

// ── Results Screen ────────────────────────────────────────────────────────────
function ResultsScreen({ results, onHome }) {
    const { score, correct, total, title, mode } = results;
    const pct = total > 0 ? Math.round((correct / total) * 100) : 0;
    const grade = pct >= 90 ? 'S' : pct >= 70 ? 'A' : pct >= 50 ? 'B' : 'C';
    const gradeColor = { S: '#34d399', A: '#60a5fa', B: '#fb923c', C: '#f87171' }[grade];
    const emoji = pct >= 90 ? '🏆' : pct >= 70 ? '🌟' : pct >= 50 ? '👍' : '💪';

    return (
        <div className="sg-results">
            <div className="sg-results-card">
                <div className="sg-results-emoji">{emoji}</div>
                <h2 className="sg-results-title">{title}</h2>
                <div className="sg-grade-ring" style={{ '--gc': gradeColor }}>
                    <span className="sg-grade-letter">{grade}</span>
                </div>
                <div className="sg-results-stats">
                    <div className="sg-stat"><span>{correct}</span><label>Correct</label></div>
                    <div className="sg-stat"><span>{total - correct}</span><label>Wrong</label></div>
                    <div className="sg-stat"><span>{pct}%</span><label>Accuracy</label></div>
                </div>
                <div className="sg-results-btns">
                    <button className="sg-btn-primary" onClick={onHome}>🏠 Back to library</button>
                </div>
            </div>
        </div>
    );
}